import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserGuard } from './core/guards/user.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then((m) => m.LoginNovoModule)
  },
  {
    path: 'login-ad',
    loadChildren: () => import('./modules/login-ad/login-ad.module').then((m) => m.LoginAdModule)
  },
  {
    path: 'recuperar-senha',
    loadChildren: () =>
      import('./modules/recuperar-senha/recuperar-senha.module').then(
        (m) => m.RecuperarSenhaNovoModule
      )
  },
  {
    path: 'alterar-senha',
    loadChildren: () =>
      import('./modules/alterar-senha/alterar-senha.module').then((m) => m.AlterarSenhaModule)
  },
  {
    path: 'registrar',
    loadChildren: () =>
      import('./modules/registrar/registrar.module').then((m) => m.RegistrarNovoModule)
  },
  {
    path: 'boas-vindas',
    loadChildren: () =>
      import('./modules/boas-vindas/boas-vindas.module').then((m) => m.BoasVindasModule)
  },
  {
    path: 'page',
    canLoad: [UserGuard],
    loadChildren: () => import('./modules/pages/pages.module').then((m) => m.PagesModule)
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/landing-page/landing-page.module').then((m) => m.LandingPageModule)
  },
  {
    path: 'l/:path',
    loadChildren: () => import('./modules/link/link.module').then((m) => m.LinkModule)
  },
  {
    path: 'votacao/2026',
    loadChildren: () => import('./modules/votacao/votacao.module').then((m) => m.VotacaoModule)
  },
  { path: '', pathMatch: 'full', redirectTo: '' },
  { path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
